export enum SearchStates {
  initial = 0,
  loading = 1,
  filled = 2,
}
